/**
 * @author PANJC
 *
 */
define(function (require) {
  var cloud = require("cloud/base/cloud");
  var html = require("./header.html");
  var css = require("../resources/css/header.css");
  var Header = Class.create(cloud.Component, {
    initialize: function ($super, options) {
      $super(options);
      this.oldValue = null;
      this.language = null;
      this._render();
      this.gotoTop();
    },

    /*返回顶部处理函数*/
    gotoTop: function () {
      //为窗口的scroll事件绑定处理函数
      $(window).scroll(function () {
        //获取窗口的滚动条的垂直位置
        var s = $(window).scrollTop();
        //当窗口的滚动条的垂直位置大于300px时，让返回顶部元素渐现，否则渐隐
        if (s > 300) {
          $("#returnTop").fadeIn(100);
        } else {
          $("#returnTop").fadeOut(200);
        }
      });
      $("#returnTop").click(
        function () {
          $('html,body').animate({scrollTop: 0}, 1000);
        }
      );


    },
    _render: function () {
      var self = this;
      if (sessionStorage.getItem("accessToken")) {
        location.href = "../applications";
      }
      this._renderHtml();
      var flag = 0;
      $("#select-language").bind("click", function () {
        if(flag == 0){
          $(".dropdown-menu").css("display","block");
          flag = 1;
        }else{
          $(".dropdown-menu").css("display","none");
          flag = 0;
        }
      });
      //var lang = localStorage.getItem("language");
      var lang = "en";
      if(lang == 'en'){
        $("#device-touch .home-intro-bottom .panel").css("height","178px");
        $("#device-sense .home-intro-bottom .row:first .panel").css("height","190px");
        $("#device-sense .home-intro-bottom .row:last .panel").css("height","215px");
        $("#device-manager .home-intro-bottom .row:first .panel").css("height","210px");
        $("#device-manager .home-intro-bottom .row:last .panel").css("height","260px");
        $(".alarm-app").css("font-size", "17px");
      }else{
        $("#device-touch .home-intro-bottom .panel").css("height","145px");
        $("#device-sense .home-intro-bottom .row:first .panel").css("height","145px");
        $("#device-sense .home-intro-bottom .row:last .panel").css("height","190px");
        $("#device-manager .home-intro-bottom .row:first .panel").css("height","145px");
        $("#device-manager .home-intro-bottom .row:last .panel").css("height","176px");
        $(".alarm-app").css("font-size", "20px");
      }
      //$("#lang-en").bind("click", function () {
        locale.set({lang: "en"});
        self._setAboutUsLink('en');  // set about us url
        validator.render(validator.element, validator.paramObj);
        self._promptCurrentLang();
        self._changeLanguageEvent();
        $(".dropdown-menu").css("display","none");
        flag = 0;
        $("#device-touch .home-intro-bottom .panel").css("height","178px");
        $("#device-sense .home-intro-bottom .row:first .panel").css("height","190px");
        $("#device-sense .home-intro-bottom .row:last .panel").css("height","215px");
        $("#device-manager .home-intro-bottom .row:first .panel").css("height","210px");
        $("#device-manager .home-intro-bottom .row:last .panel").css("height","260px");
        $(".fax").css("display","none");
        $(".alarm-app").css("font-size", "17px");
      //});
      //$("#lang-zh").bind("click", function () {
      //  locale.set({lang: "zh_CN"});
      //  self._setAboutUsLink('zh_CN');
      //  validator.render(validator.element, validator.paramObj);
      //  self._promptCurrentLang();
      //  self._changeLanguageEvent();
      //  $(".dropdown-menu").css("display","none");
      //  $(".fax").css("display","block");
      //  flag = 0;
      //  $("#device-touch .home-intro-bottom .panel").css("height","145px");
      //  $("#device-sense .home-intro-bottom .row:first .panel").css("height","145px");
      //  $("#device-sense .home-intro-bottom .row:last .panel").css("height","190px");
      //  $("#device-manager .home-intro-bottom .row:first .panel").css("height","145px");
      //  $("#device-manager .home-intro-bottom .row:last .panel").css("height","176px");
      //  $(".alarm-app").css("font-size", "20px");
      //});
      this._promptCurrentLang();
      this._event();
    },

    _renderHtml: function () {
      this.element.html(html);
    },
    _setAboutUsLink: function (lang) {
      if (lang == 'en') {
        $("#home-nav-aboutus").children("a").attr("href", "http://www.inhandnetworks.com/");
      } else if (lang == 'zh_CN') {
        $("#home-nav-aboutus").children("a").attr("href", "http://www.inhand.com.cn/");
      }
    },
    _promptCurrentLang: function () {
      var lang = localStorage.getItem("language");
      if (lang == "en") {
        $("#lang-zh").css("color", "#555");
        $("#lang-en").css("color", "#83a82f");
      } else if (lang == "zh_CN") {
        $("#lang-zh").css("color", "#83a82f");
        $("#lang-en").css("color", "#555");
      }
    },

    _changeLanguageEvent: function () {
      if ($("#change-language").length > 0) {
        $("#change-language").trigger("click");
      }
    },

    _event: function () {
      var self = this;
      var $search = $("#search");
      var oldValue, newValue;
      $search.bind("focus", function () {
        if (!self.language) {
          self.language = localStorage.getItem("language");
        }
        if (!self.oldValue) {
          self.oldValue = $search.val();
        } else {
          if (self.language != localStorage.getItem("language")) {
            self.oldValue = $search.val();
            self.language = localStorage.getItem("language");
          }
        }
        if (self.oldValue == $search.val()) {
          $search.val("");
        }
      });
      $search.bind("focusout", function () {
        newValue = $search.val();
        if (!newValue) {
          $search.val(self.oldValue);
        }
      });
    }

  });

  return Header;

});



//////////////////
// WEBPACK FOOTER
// ./DeviceNetwork/www/common/header.js
// module id = 38
// module chunks = 0 49